<div class="component-heading">
    <span matTooltip="{{title? title: ''}}">{{title ? title : ''}}</span>
    <button *ngIf="activityFeedLoaded" mat-button class="grid-mini-button" [matMenuTriggerFor]="menu">
        <i class="fa-solid fa-ellipsis"></i>
    </button>
    <mat-menu #menu="matMenu" class="action-button-dropdown-container v2-0-menu" [overlapTrigger]="false">
        <button mat-menu-item class="flex flex-row justify-start items-center"
                (click)="refreshFeedsInfo()">
            <i class="far fa-sync-alt"></i>
            <span>Refresh</span>
        </button>
        <button mat-menu-item class="flex flex-row justify-start items-center"
                (click)="activityHeaderDateChange()">
            <i class="fas fa-pencil-alt"></i>
            <span>Date Range</span>
        </button>
        <button mat-menu-item class="flex flex-row justify-start items-center"
                (click)="onToggleSupportOnly()">
            <i class="far fa-headset"></i>
            <span>Support activities only</span>
            <i *ngIf="supportOnly" class="far fa-check m-l-10"></i>
        </button>
        <button mat-menu-item class="flex flex-row justify-start items-center"
                (click)="onExportActivityFeeds()">
            <i class="far fa-file-export"></i>
            <span>Export (Excel)</span>
        </button>
        <!--<button mat-menu-item class="flex flex-row justify-start items-center"
                (click)="onNotificationSettings()"
                *ngIf="platformLinkModel?.activityFeedInfo?.type?.toLowerCase() === activityFeedTypes.ReferenceCode.toLowerCase()">
          <i class="far fa-bell-exclamation"></i>
          <span>Notifications</span>
        </button>-->
    </mat-menu>
</div>

<mat-tab-group [(selectedIndex)]="this.selectedTabIndex" (selectedTabChange)="onSelectedTabChange($event)" class="activity-switch-tabs blue-line-minimal-tabs sidebar-tabs">
    <mat-tab>
        <ng-template matTabLabel>
            <i class="fas fa-history"></i>
            <span>Edit History</span>
        </ng-template>
        <div class="tab-body flex flex-col">
            <particle-activity-cards
                    *ngIf="activityFeedLoaded"
                    [data]="data"
                    [activityFeeds]="activityFeeds"
                    [activitiesRootEvent$]="activitiesRootEvent$"
                    [showChatEditor]="showChatEditor"
                    [supportOnly]="supportOnly"
                    (activityFeedInfoEvent$)="handleActivityFeedInfoEvent($event)">
            </particle-activity-cards>
            <app-data-sources-field-history-details
                    *ngIf="dataSourcesFieldHistoryLoaded"
                    [hidden]="!dataSourcesFieldHistoryOpened"
                    [invalidate]="invalidateDataSourcesFieldHistory"
                    [destinationType]="data.DestinationType"
                    [sourceType]="data.SourceType"
                    [itemId]="data.ItemId"
                    [fieldKey]="data.FieldKey"
                    [workbookId]="data.WorkbookId"
                    [worksheetId]="data.WorksheetId"
                    [cellRowIndex]="data.CellRowIndex"
                    [cellColumnIndex]="data.CellColumnIndex"
                    [referenceCode]="data.ReferenceCode"
                    (fieldHistoryEvent)="handleFieldHistoryEvent($event)">
            </app-data-sources-field-history-details>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template matTabLabel>
            <i class="fa fa-layer-group"></i>
            <span>Data Tracing</span>
        </ng-template>
        <div class="tab-body">
          <div class="data-tracing-container">
            <app-latest-data-sources
                *ngIf="dataSourcesLoaded"
                [invalidate]="invalidateDataSources"
                [data]="data"
                (dataSourcesEvent)="handleDataSourcesEvent($event)">
            </app-latest-data-sources>
          </div>
        </div>
    </mat-tab>
</mat-tab-group>
